export default class Alert {
	constructor() {
		this.node = document.querySelector('.alert');

		if (!this.node) {
			return;
		}

		this.classes = {
			bodyClass: 'has-alert'
		}

		this.closer = this.node.querySelector('.alert__close');

		if (this.closer) {
			this.closer.addEventListener('click', () => this.close());
		}

		if (this.node.dataset.alert && localStorage.getItem(this.node.dataset.alert)) {
			this.node.style.display = 'none';
		}

	}

	close() {
		//close alert, get new height of alertContent & change header top position
		//localStorage to remember what's been closed
		//	console.log(this.node.dataset.alert);

		this.node.style.display = 'none';

		if (this.node.dataset.alert) {
			localStorage.setItem(this.node.dataset.alert, true);
		}
	}
}




